/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from "@shared/DbBaseObject.js";
import {Type} from "class-transformer";
import {TimeInterval} from "@shared/scheduler/TimeInterval";


export class BusyTimeResponse extends DbBaseObject{

	@Type(() => TimeInterval)
	timeIntervals: TimeInterval[] = []

	scheduledCountByDays: {} //{'dd-mm-yyyy1': number, 'dd-mm-yyyy2': number etc...}



}
